import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMicrosoftOneNote = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	...props,
	children: [
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .2,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 11.9819,
				y: 5.68213,
				width: 29.8181,
				height: 34.4378,
				fill: "url(#pattern0_2088_9114)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .2,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M38.5971 5.85718H14.9211C14.1093 5.85718 13.4512 6.51528 13.4512 7.32709V35.9378C13.4512 36.7496 14.1093 37.4077 14.9211 37.4077H38.5971C39.4089 37.4077 40.067 36.7496 40.067 35.9378V7.32709C40.067 6.51528 39.4089 5.85718 38.5971 5.85718Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .12,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 12.6646,
				y: 5.52466,
				width: 28.1382,
				height: 32.7579,
				fill: "url(#pattern1_2088_9114)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .12,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M38.5981 5.85693H14.9221C14.1102 5.85693 13.4521 6.51503 13.4521 7.32684V35.9375C13.4521 36.7493 14.1102 37.4074 14.9221 37.4074H38.5981C39.4099 37.4074 40.068 36.7493 40.068 35.9375V7.32684C40.068 6.51503 39.4099 5.85693 38.5981 5.85693Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M37.9332 37.3726H14.9222C14.7285 37.3749 14.5363 37.3385 14.3569 37.2654C14.1775 37.1924 14.0145 37.0842 13.8775 36.9473C13.7406 36.8103 13.6324 36.6473 13.5594 36.4679C13.4863 36.2885 13.4499 36.0963 13.4523 35.9026V7.32695C13.4499 7.13327 13.4863 6.94107 13.5594 6.76167C13.6324 6.58228 13.7406 6.4193 13.8775 6.28234C14.0145 6.14537 14.1775 6.03719 14.3569 5.96415C14.5363 5.89111 14.7285 5.85469 14.9222 5.85704H38.5807C38.7743 5.85469 38.9665 5.89111 39.1459 5.96415C39.3253 6.03719 39.4883 6.14537 39.6253 6.28234C39.7622 6.4193 39.8704 6.58228 39.9435 6.76167C40.0165 6.94107 40.0529 7.13327 40.0506 7.32695V35.3252C40.0281 35.8731 39.7957 36.3913 39.4015 36.7725C39.0073 37.1536 38.4815 37.3685 37.9332 37.3726Z",
			fill: "#CA64EA"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0678 13.7314H32.1758V21.6234H40.0678V13.7314Z",
			fill: "#AE4BD5"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M40.0678 21.6235H32.1758V29.5155H40.0678V21.6235Z",
			fill: "#9332BF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M32.1758 29.5156H40.0678V35.9202C40.0678 36.3147 39.9111 36.693 39.6321 36.972C39.3532 37.2509 38.9749 37.4076 38.5804 37.4076H32.1758V29.5156Z",
			fill: "#7719AA"
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .48,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 2.2002,
				y: 10.5996,
				width: 24.7784,
				height: 24.7784,
				fill: "url(#pattern2_2088_9114)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .48,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M21.8165 12.752H7.04747C6.22599 12.752 5.56006 13.4179 5.56006 14.2394V29.0084C5.56006 29.8299 6.22599 30.4958 7.04747 30.4958H21.8165C22.638 30.4958 23.3039 29.8299 23.3039 29.0084V14.2394C23.3039 13.4179 22.638 12.752 21.8165 12.752Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsxs("g", {
			style: { mixBlendMode: "multiply" },
			opacity: .24,
			children: [/* @__PURE__ */ _jsx("rect", {
				x: 5.10547,
				y: 12.2444,
				width: 18.8988,
				height: 18.8988,
				fill: "url(#pattern3_2088_9114)"
			}), /* @__PURE__ */ _jsx("g", {
				opacity: .24,
				style: { mixBlendMode: "multiply" },
				children: /* @__PURE__ */ _jsx("path", {
					d: "M21.8165 12.752H7.04747C6.22599 12.752 5.56006 13.4179 5.56006 14.2394V29.0084C5.56006 29.8299 6.22599 30.4958 7.04747 30.4958H21.8165C22.638 30.4958 23.3039 29.8299 23.3039 29.0084V14.2394C23.3039 13.4179 22.638 12.752 21.8165 12.752Z",
					fill: "white"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.8165 12.752H7.04747C6.22599 12.752 5.56006 13.4179 5.56006 14.2394V29.0084C5.56006 29.8299 6.22599 30.4958 7.04747 30.4958H21.8165C22.638 30.4958 23.3039 29.8299 23.3039 29.0084V14.2394C23.3039 13.4179 22.638 12.752 21.8165 12.752Z",
			fill: "#7719AA"
		}),
		/* @__PURE__ */ _jsx("g", {
			style: { mixBlendMode: "soft-light" },
			opacity: .5,
			children: /* @__PURE__ */ _jsx("path", {
				opacity: .5,
				d: "M21.8165 12.752H7.04747C6.22599 12.752 5.56006 13.4179 5.56006 14.2394V29.0084C5.56006 29.8299 6.22599 30.4958 7.04747 30.4958H21.8165C22.638 30.4958 23.3039 29.8299 23.3039 29.0084V14.2394C23.3039 13.4179 22.638 12.752 21.8165 12.752Z",
				fill: "url(#paint0_linear_2088_9114)",
				style: { mixBlendMode: "soft-light" }
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.4246 16.8113H12.4194L16.3042 23.1984C16.4544 23.416 16.5889 23.644 16.7067 23.8808C16.6803 23.4438 16.6803 23.0055 16.7067 22.5684V16.8113H18.4566V26.4357H16.5667L12.4894 19.8736C12.3452 19.6647 12.2221 19.4419 12.122 19.2086C12.1471 19.6866 12.1471 20.1656 12.122 20.6435V26.4357H10.3721L10.4246 16.8113Z",
			fill: "white"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern0_2088_9114",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image0_2088_9114",
					transform: "scale(0.0138889 0.0120482)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern1_2088_9114",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image1_2088_9114",
					transform: "scale(0.0147059 0.0126582)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern2_2088_9114",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image2_2088_9114",
					transform: "scale(0.0166667)"
				})
			}),
			/* @__PURE__ */ _jsx("pattern", {
				id: "pattern3_2088_9114",
				patternContentUnits: "objectBoundingBox",
				width: 1,
				height: 1,
				children: /* @__PURE__ */ _jsx("use", {
					xlinkHref: "#image3_2088_9114",
					transform: "scale(0.0217391)"
				})
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_2088_9114",
				x1: 8.63986,
				y1: 11.597,
				x2: 20.2241,
				y2: 31.6508,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", {
					stopColor: "white",
					stopOpacity: .5
				}), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopOpacity: .7
				})]
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image0_2088_9114",
				width: 72,
				height: 83,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABTCAYAAAA8/EEfAAAACXBIWXMAAC4jAAAuIwF4pT92AAAB80lEQVR4Xu3cMUvDUBiF4ffWoOigIjgoFsFJEGeXbv51QdSfoaKgCB0bq9fhy42p1h5wTM67pLRd8nCT8aScM91SSokBln9CNKXyfQNTAevAGjAUqAx8ADUw/wmVcs4FZwPYB46AHYaBVHCmwAPwAsy6SFXnug9cABNgTJykIVQD98AVcAM8A+/lx6o5PevEyZkAl8AB33h9bw48NZ8fgbeUUvuoFYQ14rEaEzi7wIhh9Nlcx3y/WtoKUPcFXRE4fX//lEYs3vvCfQ/llPw7A4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQyEAiA4kMJDKQqABlYi6vbq5LZzt72sp7Lyt4ZY3ynhharIAt+r/GmYEZ8EoscU4Ji7Yq55xTSnXzhysC5ww4Brbp9+DknMC5Ba4Jg7o7Vbpsy/UEOAXOidHJPk+WloNxDdwRS5yzX0CwsAa8CewBh8QJ6utjJoduoQPUfpHSiEAZwmzyyqlkWALU/jCg4e2/xrZhBZCLvgDnzoNhQUCRAwAAAABJRU5ErkJggg=="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image1_2088_9114",
				width: 68,
				height: 79,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEQAAABPCAYAAABS1GNxAAAACXBIWXMAAC4jAAAuIwF4pT92AAABXUlEQVR4Xu3csY0TQQBG4TcW0jZx2TVBRkZDZBRARkFkF1LBRefMRdjREKwXmXcBxMz7pJWllWVpn3Yc/mPOCcAYYwOegI113IDLnPN23BhzziPGR+Are5RVXIBvwM/fUe5vyDPwA7gCc6HrCrwAn4DtOC0b8Bl4+4cf+B+vK/vL8Dzn5MR+RL6w1lF59Md/58k3Vnf62xdWUxApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiBRECiIFkYJIQaQgUhApiJy4j5vdP1f07vlXn+16Y3/+bc7JhznnbYxxBl7ZrbJYdbwZr8D5WLp7nP57Yl+8W2XT7AJ8B8487CGOY+4OlhuIfDcMCQoS+AUKhwf2M9jJXwAAAABJRU5ErkJggg=="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image2_2088_9114",
				width: 60,
				height: 60,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAYAAAA6/NlyAAAACXBIWXMAAC4jAAAuIwF4pT92AAADoUlEQVRoQ+2b61LbMBBGj3IhoUAphbbT93+6Ti8DoZCEXNwfq43WshyHUizi+pvZ8SWO2ONd2WH82RVFwf+kUdMBKTnnXNMxr63iLyvl9n3PgFnA7LBGhV0echJqgT2sAwZ+add3hyW++tqykBpbu70PPAnsnBsgcANgGIU9AbmANTaJ2ALbOujKHDawI2AMnJgY+dBjoF1ohdgicGtgBTyZWAE455LQJWDfxgo7AabAO+AMOPX7TqhWui3ZFl4jgHPg0YTz+5PQO+Bozo4RwAvg0sd7BH7qPx/S3ny2SWt1Vwjsb2AG3CI56fE2dopbWqt7gsBdAp+AG+Cj3z6lXOU2pQBrYAk8AHfATwJLaT4755ytsgXWCg+R1j0DPiDAX4HPwBVwTpjPOVpa23kJ3AO/kHwx+5dIW6/jAVIVHiJAp0gbXwNfEOhrpM0nhJbOAbwBFkgrT/1nWvF7v9QO1FsWUAXWCo+Rgc4Q6CukrW/ID6wtvSBUdoG09jlSqNQ1BvDA5oKlFy2tsl6lz31c8DaAN0h+IJW9INxJdLol80v9lrbQ9l48iSI3MMg8nRJyGpOAtReuVEvr0oLbGJn1NmFVOh9tLiOzrj+KkrnVVTgVdiAbOVSXlwVN5nfofTT+Yi5QVV1RiNYragLODfbP1QR8bGosUNeAG9UDd109cNfVA3ddPXDX1QN3XT1w19UDd109cNfVA3ddPXDX1QMfuWrdO6om4MYBjk1NwKoYPPeJiD0c1stR8XVY1VkP4wHsvvgPtK04hy3hKb992p/MMQauGyxlAIP2nyBqXprD2ix13Z6AilIVtoOq8UvNX0vCk/ccz4dtbgsTamRZEcB3Fa64eIqiKLyPVKuqsEs/4IMPNZA8kRdYPR4zH2pkmRPcOyVola2wbeMVAvvoB7tF/BMgf0h9WjmAYxfPD8S6dIeY1OZI/gpcUmoOq8tNYa0Pao6YR9QlA+1CK3Ds0/qGmNNmSN5PhPm8t8J69rS6d5TdMrcE66G1F7Ql29KxE+87kp8FPqjCatp8RAbAb88QC9OE4KhVvTa4TXyf1zKucMU7vQP2F664pUFOgFZbYXNYlqB8nalz0y6Q/JO3ppJB3BjU1I1nPVq6bWFzAEOzX3pDjUm84oiPbMSxL2tAmLttw6oKE6kfRHsd8XWvAMR2oEG0jVm2rcIsbYvvtp/9zsPuw+pbLbkg62ThX/ZWS53ewjtLcBhcSs8GPnYd+v9wZ/QHTbqvfA0XAmsAAAAASUVORK5CYII="
			}),
			/* @__PURE__ */ _jsx("image", {
				id: "image3_2088_9114",
				width: 46,
				height: 46,
				preserveAspectRatio: "none",
				xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAC4AAAAuCAYAAABXuSs3AAAACXBIWXMAAC4jAAAuIwF4pT92AAAAwUlEQVRoQ+3ZsQkCMRyF8S8iZAm765zAzr0cwJ3sLG8BN8gQSfW3CIdeZ/VM4P0gTSDwcXDVSxFBSikDJyAzpgaUiGjbRaLHXoAbPX5EBbgD63f8AjyACsSgpwJP4ArkiADgDLx+ePzvU+kfeIkIDsxj9x/OFL7jcDWHqzlczeFqDldzuJrD1Ryu5nA1h6s5XM3hag5Xc7iaw9UcruZwNYcLNPre2aCH7y4G1YCVPtIWgCOf1RYmWpbTtFv+Ni/P5g1xTodLg4W2uAAAAABJRU5ErkJggg=="
			})
		] })
	]
});
export default SvgMicrosoftOneNote;
